import { NotificationList } from "../components/NotificationList";
import { Button } from "../components/base";
import { PageLayout } from "../components/PageLayout";
import { useAppDispatch, useAppSelector } from "../redux";
import { markAllAsRead } from "../redux/reducers/notificationSlice";

export const NotificationsPage = () => {
  const dispatch = useAppDispatch();
  const { unreadCount } = useAppSelector((state) => state.notifications);

  const handleMarkAllRead = () => {
    dispatch(markAllAsRead());
  };

  return (
    <PageLayout
      title="Notifications"
      description="Your recent alerts and activity"
      headerAction={
        unreadCount > 0 ? (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={handleMarkAllRead}
          >
            Mark all read
          </Button>
        ) : undefined
      }
    >
      <NotificationList showFilters />
    </PageLayout>
  );
};
